import React from "react";
import { ProgressBar } from "react-loader-spinner";

const PopupLoading = ({ loadingText }) => {
  return (
    <div className="min-w-[100vw] w-full h-screen flex justify-center items-center bg-[#241b4795] backdrop-blur-md fixed top-0 left-0 z-50 ">
      <div className="w-72 pt-10 flex flex-col justify-center items-center rounded-2xl bg-custom-gray-300 ">
        <span className="text-2xl uppercase">{loadingText}</span>
        <ProgressBar
          height="120"
          width="120"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#241B47"
          barColor="#8538FF"
        />
      </div>
    </div>
  );
};

export default PopupLoading;
